(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bstore-occasion-delivery-ack"] && !Shopify.designMode) return;
  try {
    (() => {
    const pendingActions = new WeakMap();
    const requireDeliveryAcknowledgment = (event, form, giftTrigger = null) => {
      const checkbox = form?.querySelector('[data-bstore-delivery-ack]');
      if (!checkbox || checkbox.checked) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const dialog = form.querySelector('[data-bstore-delivery-dialog]');
      pendingActions.set(dialog, {form, checkbox, giftTrigger, submitter: event.submitter});
      if (!dialog.open) dialog.showModal();
    };
    window.addEventListener('submit', event => requireDeliveryAcknowledgment(event, event.target), true);
    window.addEventListener('click', event => {
      const confirm = event.target.closest('[data-bstore-delivery-confirm]');
      const cancel = event.target.closest('[data-bstore-delivery-cancel]');
      if (confirm || cancel) {
        event.preventDefault();
        const dialog = (confirm || cancel).closest('[data-bstore-delivery-dialog]');
        const pending = pendingActions.get(dialog);
        pendingActions.delete(dialog);
        dialog.close();
        if (confirm && pending) {
          pending.checkbox.checked = true;
          pending.checkbox.dispatchEvent(new Event('change', {bubbles: true}));
          if (pending.giftTrigger) pending.giftTrigger.click();
          else pending.form.requestSubmit(pending.submitter || undefined);
        }
        return;
      }
      const giftButton = event.target.closest('[data-bstore-open-gifts]');
      if (giftButton) requireDeliveryAcknowledgment(event, giftButton.closest('form'), giftButton);
    }, true);
    window.addEventListener('change', event => {
      if (!event.target.matches('[data-bstore-delivery-ack]')) return;
      if (event.target.checked) {
        event.target.removeAttribute('aria-invalid');
        event.target.closest('.bstore-delivery-ack').querySelector('[data-bstore-delivery-error]').hidden = true;
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bstore-promotional-badge"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bstore-responsive-promos')) {
    customElements.define('bstore-responsive-promos', class extends HTMLElement {
      connectedCallback() {
        const card = this.closest('.product-item');
        if (!card || this.resizeObserver) return;
        this.phoneQuery = window.matchMedia('(max-width: 768px)');
        this.updateBadges = () => {
          const width = card.getBoundingClientRect().width;
          if (!width) return;
          const style = getComputedStyle(this);
          const setting = window.matchMedia('(max-width: 768px)').matches ? '--bstore-promo-mobile-size' : '--bstore-promo-size';
          const badgeSize = parseFloat(style.getPropertyValue(setting)) || 110;
          this.style.setProperty('--b-family-badge-scale', Math.min(1, width * .28 / Math.max(badgeSize, 104)).toFixed(4));
          this.dataset.familyCompact = String(this.phoneQuery.matches);
        };
        this.resizeObserver = new ResizeObserver(this.updateBadges);
        this.resizeObserver.observe(card);
        this.phoneQuery.addEventListener('change', this.updateBadges);
        this.updateBadges();
      }
      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        this.phoneQuery?.removeEventListener('change', this.updateBadges);
        this.resizeObserver = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
